import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function getProdutos(empresaId) {
  try {
    const response = await authHttp().get(routes.urlGetProdutos(empresaId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getProductsByCompanyAndEan(empresaId, codigoBarras) {
  try {
    const response = await authHttp().get(
      routes.urlGetProductsByCompanyIdAndEan(empresaId, codigoBarras),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getProdutosWithEanOnExcel(empresaId) {
  return routes.urlGetProdutosWithEanOnExcel(empresaId)
}

export async function getProdutosSemEanOnExcel(empresaId) {
  return routes.urlGetProdutosSemEanOnExcel(empresaId)
}

export async function getProdutosCodigoBarrasReport(empresaId, tipo) {
  return routes.urlReportCodigoBarrasProdutos(empresaId, tipo)
}

export async function saveProduto(produto) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlSalvarProduto, {
      ...produto,
      updated_by: user_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveProdutoComEan(produto) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlSalvarProdutoComEan, {
      ...produto,
      updated_by: user_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateProduto({
  id,
  product_code,
  company_id,
  name,
  weight,
  unit_sku,
  m3,
  actived,
  ordem_separacao,
  caixa_com_peso_variavel,
  grupo_produto_id,
  weight_liquido,
  qte_por_pallet,
  dias_para_vencimento,
  participa_calculo_paletizacao,
  picking_add_lote,
  picking_add_data_validade,
  picking_add_data_fabricacao,
  picking_add_info_complementar,
  picking_add_lote_recebimento,
  picking_add_data_validade_recebimento,
  inventario_add_lote,
  inventario_add_data_validade,
  un_agregadora,
  un_fracionada,
  estoque_minimo,
}) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(routes.urlSalvarProduto, {
      id,
      product_code,
      company_id,
      name,
      weight,
      unit_sku,
      m3,
      actived,
      ordem_separacao,
      caixa_com_peso_variavel,
      grupo_produto_id,
      weight_liquido,
      qte_por_pallet,
      dias_para_vencimento,
      updated_by: user_id,
      participa_calculo_paletizacao,
      picking_add_lote,
      picking_add_data_validade,
      picking_add_data_fabricacao,
      picking_add_info_complementar,
      picking_add_lote_recebimento,
      picking_add_data_validade_recebimento,
      inventario_add_lote,
      inventario_add_data_validade,
      un_agregadora,
      un_fracionada,
      estoque_minimo,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEans(produtoId) {
  try {
    const response = await authHttp().get(routes.urlGetEans(produtoId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarEan(ean, productId, qte_caixa) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlSalvarEan(productId), {
      ean,
      qte_caixa,
      inserted_by: user_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteEan(eanId) {
  try {
    await authHttp().delete(routes.urlDeleteEan(eanId))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDesdobramentos(produtoOrigemId) {
  try {
    const response = await authHttp().get(routes.urlGetDesdobramento(produtoOrigemId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveDesdobramentos(desdobramentos, produtoOrigemId) {
  try {
    const response = await authHttp().post(
      routes.urlGetDesdobramento(produtoOrigemId),
      desdobramentos,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPosicoesEstoquePadraoProduto(produtoId, tpId) {
  try {
    const response = await authHttp().get(
      routes.urlGetPosicoesEstoquePadraoProduto(produtoId, tpId),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function savePosicaoEstoquePadraoProduto(produtoId, tpId, posicaoEstoqueId) {
  try {
    const response = await authHttp().post(
      routes.urlGetPosicoesEstoquePadraoProduto(produtoId, tpId),
      {
        posicao_estoque_id: posicaoEstoqueId,
      },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deletePosicaoEstoquePadraoProduto(produtoId, tpId, id) {
  try {
    const response = await authHttp().delete(
      routes.urlDeletePosicaoEstoquePadraoProduto(produtoId, tpId, id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getProdutoDePara(produtoParaId) {
  try {
    const response = await authHttp().get(routes.urlGetProdutoDePara(produtoParaId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveProdutoDePara(produtoParaId, produtoDeId, convertFactor, unidadePara) {
  try {
    const response = await authHttp().post(routes.urlGetProdutoDePara(produtoParaId), {
      product_de: produtoDeId,
      convert_factor: convertFactor,
      unidade_para: unidadePara,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteProdutoDePara(produtoParaId, id) {
  try {
    const response = await authHttp().delete(routes.urlDeleteProdutoDePara(produtoParaId, id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
